<template>
  <el-skeleton class="sk" animated>
    <template #template>
      <div class="sk__top">
        <div class="sk__column">
          <p class="sk__table-title">{{ t('profile.orders.order') }}</p>
        </div>
        <div class="sk__column">
          <p class="sk__table-title">{{ t('profile.orders.date') }}</p>
        </div>
        <div class="sk__column">
          <p class="sk__table-title">{{ t('profile.orders.status') }}</p>
        </div>
        <div class="sk__column">
          <p class="sk__table-title">{{ t('profile.orders.total') }}</p>
        </div>
        <div class="sk__column">
          <p class="sk__table-title">{{ t('profile.orders.details') }}</p>
        </div>
      </div>
      <div class="sk__item">
        <div class="sk__item-column">
          <el-skeleton-item variant="p" class="sk__text" />
        </div>
        <div class="sk__item-column">
          <el-skeleton-item variant="p" class="sk__text" />
        </div>
        <div class="sk__item-column">
          <el-skeleton-item variant="p" class="sk__text" />
        </div>
        <div class="sk__item-column">
          <el-skeleton-item variant="p" class="sk__text" />
        </div>
        <div class="sk__item-column">
          <el-skeleton-item variant="p" class="sk__text" />
        </div>
      </div>
    </template>
  </el-skeleton>
</template>

<script setup>
import {useI18n} from "vue-i18n";

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.sk {
  width: 100%;

  &__top {
    display: flex;
    align-items: center;
    border-bottom: 2px solid #E4E4E4;
    padding-bottom: 10px;
  }

  &__column {
    &:nth-child(1) {
      width: 15%;
    }
    &:nth-child(2) {
      width: 30%;
    }
    &:nth-child(3) {
      width: 18%;
    }
    &:nth-child(4) {
      width: 30%;
    }
    &:nth-child(5) {
      width: 10%;
      display: flex;
      justify-content: flex-end;
    }
  }

  &__item {
    padding-block: 14px;
    display: flex;
    align-items: center;

    &-column {
      &:nth-child(1) {
        width: 15%;
      }
      &:nth-child(2) {
        width: 30%;
      }
      &:nth-child(3) {
        width: 18%;
      }
      &:nth-child(4) {
        width: 30%;
      }
      &:nth-child(5) {
        width: 10%;
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  &__text {
    width: 75%;
    height: 22px;
  }
}

:deep(.el-skeleton__item) {
  --el-skeleton-color: #c9ccd0 !important;
  --el-skeleton-to-color: #c3c3c7 !important;
}
</style>